import { Switch } from 'antdV3';
import { ReactComponent as SVGDarkMode } from '@features/regional-overview/assets/components/svg-dark-mode.svg';
import { MapboxStyle } from 'components/map/core-map.constants';
import MapBoxService from 'components/map/sd-mapbox.service';
import type { mapboxgl } from 'core/utils/map/mapbox-gl';
import useSegmentTracking from 'core/utils/segment/useSegmentTracking';
import { REGIONAL_RISK_SWITCHER } from '@features/regional-overview/domain/tests-id.constants';
import type React from 'react';
import { useCallback, useState } from 'react';
import { RegionalRiskSwitchContainer } from './regional-risk-change-mode.styles';

interface IRegionalRiskChangeMode {
  mapbox: mapboxgl.Map | undefined;
  mapboxIsLoaded: boolean;
}

const RegionalRiskChangeMode: React.FC<IRegionalRiskChangeMode> = ({ mapbox }) => {
  const [modeMap, setModeMap] = useState(MapboxStyle.SATELLITE_STREETS);

  const segmentTracking = useSegmentTracking();

  const onModeMapChange = useCallback(() => {
    if (!mapbox) return;
    const newMode = modeMap === MapboxStyle.SATELLITE_STREETS ? MapboxStyle.DARK : MapboxStyle.SATELLITE_STREETS;
    setModeMap(newMode);
    MapBoxService.switchMapStyle(mapbox, newMode);

    if (newMode === MapboxStyle.DARK) {
      segmentTracking.track('Regional Risk - Changed Map to Light Mode');
    } else {
      segmentTracking.track('Regional Risk - Changed Map to Satellite Mode');
    }
  }, [mapbox, modeMap, segmentTracking]);

  return (
    <RegionalRiskSwitchContainer data-testid={REGIONAL_RISK_SWITCHER}>
      <Switch size='small' data-testid='regional-risk-map-switch' defaultChecked={false} onChange={onModeMapChange} />
      <SVGDarkMode />
    </RegionalRiskSwitchContainer>
  );
};

export default RegionalRiskChangeMode;
